// ao criar novos parâmetros siga o exemplo abaixo

export enum AnalyticsCustomPathParams {
  // CUSTOM PATHS
  //custom_path_reneg_simulacao_prazo = "/renegociacao/simulacao/a-prazo",
  //custom_path_simulacao = "/giro-aval/simulacao"
  custom_path_home = '/home',
  custom_path_login = '/login',
  custom_path_gestao_relatorios = '/gestao-relatorios',
  custom_path_movimentacao = '/movimentacao',
  custom_path_saldo_online = '/saldo-online',
  custom_path_movimentacoes_etf = '/movimentacoes-etf',
  custom_path_operadores_por_contas = '/operadoresporcontas',
  custom_path_operadores_por_contas_novo = '/operadoresporcontasnovo',
  custom_path_operadores_por_contas_vincular = '/operadoresporcontasnovo/vincular',
  custom_path_carteira_diaria = '/carteira-diaria',
  custom_path_relatorios_contabeis = '/relatorioscontabeis',
  custom_path_relatorios_gerais = '/relatorios-gerais',
  custom_path_investidor_etf = '/investidor-etf',
  custom_path_operacoes_upload = '/operacoes-upload',
  custom_path_novas_operacoes = '/operacoes-upload/novas-operacoes',
  custom_path_novas_operacoes_fundos = '/operacoes-upload/novas-operacoes-fundos',
  custom_path_novas_operacoes_carteiras = '/operacoes-upload/novas-operacoes-carteiras',
  custom_path_fundos_exclusivos = '/fundos-exclusivos',
  // TODO Verificar acoes na navbar (Taxonomia)
  custom_path_header = 'header',
  custom_path_xml = '/xml',
  custom_path_extratos = '/extratos',
  custom_path_footer = 'footer',
}
